/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

// TODO: remove, semver-major

module.exports = require('get-intrinsic');

